module.exports = __webpack_public_path__ + "img/图片13.8eb94b14.png";